export enum SessionTypes {
  AUTH_CHANGED_FAILURE = "AUTH_CHANGED_FAILURE",
  AUTH_CHANGED_SUCCESS = "AUTH_CHANGED_SUCCESS",
  AUTH_USER_UPDATE_PROFILE_SUCCESS = "AUTH_USER_UPDATE_PROFILE_SUCCESS",
}

export const userFields = [
  "uid",
  "displayName",
  "photoURL",
  "email",
  "emailVerified",
  "phoneNumber",
  "isAnonymous",
];
